/** Invitation code (`aff`) shared by Experience register pages. Format only — no lookup. */

export const affPattern = /^[A-Za-z0-9_-]{1,32}$/;

export const affInvalidMessage = '邀请码格式无效';

/** First string value of a query param. Arrays use the first entry. */
export function firstAffQueryValue(value: string | ReadonlyArray<string> | null | undefined): string {
  if (Array.isArray(value)) {
    return typeof value[0] === 'string' ? value[0] : '';
  }
  return typeof value === 'string' ? value : '';
}

export type ParsedAff =
  | { readonly ok: true; readonly aff?: string }
  | { readonly ok: false; readonly message: string };

/**
 * Empty, missing, or whitespace-only codes are omitted (registration may continue).
 * Any other value is trimmed and must match [A-Za-z0-9_-]{1,32}. Invalid codes must block submit.
 */
export function parseAff(raw: string | null | undefined): ParsedAff {
  if (raw == null) {
    return { ok: true };
  }
  const aff = raw.trim();
  if (aff.length === 0) {
    return { ok: true };
  }
  if (!affPattern.test(aff)) {
    return { ok: false, message: affInvalidMessage };
  }
  return { ok: true, aff };
}

/** Keep `aff` on the next register step. Empty input drops the param. */
export function withAffSearch(search: string, aff: string): string {
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  const trimmed = aff.trim();
  if (trimmed.length === 0) {
    params.delete('aff');
  } else {
    params.set('aff', trimmed);
  }
  const next = params.toString();
  return next.length > 0 ? `?${next}` : '';
}
